import {Component, OnInit} from "@angular/core";
import {PreguntaModelDTO} from "@Models";
import {PreguntaDTO} from "@DTOS";
import {TiposPreguntasService} from "../../tipos-preguntas.service";
import {TipoPreguntaComponent} from "../tipo-pregunta/tipo-pregunta.component";

@Component({
    templateUrl: "./tipo-pregunta-date-select.component.html",
    styleUrls: ["./tipo-pregunta-date-select.component.scss"]
})
export class TipoPreguntaDateSelectComponent extends TipoPreguntaComponent implements OnInit {

    public pregunta = new PreguntaModelDTO(new PreguntaDTO());

    constructor(private tiposPreguntaService: TiposPreguntasService) {
        super();
    }

    ngOnInit(): void {
        if (this.tiposPreguntaService.preguntaModel != null) {
            this.pregunta = this.tiposPreguntaService.preguntaModel;
        }
    }
}
